import React from 'react'
import { Box, Tooltip, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { MATCH_TIERS } from './candidateMatchUtils'

const MatchCountBar = ({ matchCounts }) => {
  const theme = useTheme()

  const total = matchCounts?.total ?? 0
  const excellent = matchCounts?.excellent ?? 0
  const strong = matchCounts?.strong ?? 0
  const potential = matchCounts?.potential ?? 0

  const tiers = [
    { count: excellent, color: theme.palette.success.main, label: MATCH_TIERS.EXCELLENT },
    { count: strong, color: theme.palette.info.main, label: MATCH_TIERS.STRONG },
    { count: potential, color: theme.palette.grey[500], label: MATCH_TIERS.POTENTIAL },
  ]

  const tooltipContent = tiers.filter(tier => tier.count > 0).map(tier => `${tier.count} ${tier.label}`).join('\n')

  return (
    <Tooltip
      title={
        <span style={{ whiteSpace: 'pre-line' }}>
          {tooltipContent}
        </span>
      }
    >
      <Box>
        <Typography variant='body2' sx={{ fontWeight: 600 }}>
          {total} matches
        </Typography>
        <Box
          sx={{
            width: 100,
            height: 6,
            borderRadius: 3,
            backgroundColor: theme.palette.grey[200],
            overflow: 'hidden',
            display: 'flex',
          }}
        >
          {total > 0 && tiers.map(tier => (
            tier.count > 0 && (
              <Box
                key={tier.label}
                sx={{
                  width: `${(tier.count / total) * 100}%`,
                  height: '100%',
                  backgroundColor: tier.color,
                }}
              />
            )
          ))}
        </Box>
      </Box>
    </Tooltip>
  )
}

export default MatchCountBar
